// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"47773f7d","9977":"47773f7d"}[chunkId] + ".chunk.css";
};